import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormChecklistPageContainer } from './audit-form-checklist-page.container';
import { useAuditFormChecklistPageViewModel } from './audit-form-checklist-page.view-model';

export const AuditFormChecklistPage = () => {
  const logger = useLogger('pages/audit-form-checklist');

  const viewModel = useAuditFormChecklistPageViewModel({
    auditFormService,
    queryClient: ReactQueryClientService.offlineQueryClient,

    logger,
  });

  return (
    <FormPageLayout
      title="Checklist"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}>
      <CenteredLayout horizontal>
        <AuditFormChecklistPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
